export class ObjectUtil
{
	/**
	 * Deeply combines source object into target object; if mutate is true, target object is changed
	 * If you don't want target mutated, start with empty object e.g. DeepMerge({}, a, b, c, ...)
	 *
	 * @param {Object} target
	 * @param {...Object} sources
	 */
	static DeepMerge(target, ...sources) {
		if (!sources.length) return target;
		const source = sources.shift();

		if (this.#Is_Js_Object(target) && this.#Is_Js_Object(source)) {
			for (const key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					const sourceValue = source[key];
					if (this.#Is_Js_Object(sourceValue) && this.#Is_Js_Object(target[key])) {
						target[key] = this.DeepMerge({}, target[key], sourceValue);
					}
					else {
						target[key] = sourceValue;
					}
				}
			}
		}
		return this.DeepMerge(target, ...sources);
	}


	static #Is_Js_Object(o) {
		return o != null && typeof o == "object" && !Array.isArray(o);
	}
}